import type { LabourItemDefinition } from '../../../api/labourItemGroupsApi';

interface GroupLabourItemsCardProps {
  labourItems: LabourItemDefinition[];
}

export function GroupLabourItemsCard({
  labourItems,
}: GroupLabourItemsCardProps) {
  return (
    <section
      className="border-t border-border-default pt-5"
      data-testid="group-labour-items-card"
    >
      <div className="mb-3 flex items-baseline justify-between gap-3">
        <h3 className="type-h6">Labour items</h3>
        <span className="type-caption text-content-secondary">
          {labourItems.length} assigned
        </span>
      </div>
      {labourItems.length === 0 ? (
        <p className="type-body-md text-content-secondary">
          No labour items assigned to this group.
        </p>
      ) : (
        <ul className="m-0 list-none divide-y divide-border-default p-0">
          {labourItems.map(item => (
            <li
              key={item.id}
              className="type-body-md py-2.5"
              data-testid={`group-item-${item.id}`}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
